import { Forward5, Pause, PlayArrow, Replay5, Fullscreen, Subtitles } from "@mui/icons-material";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";

import VideoRateControl from "./VideoRateControl";
import VolumeControl from "./VolumeControl";

interface TSControlsProps {
  isPlaying: boolean;
  isMuted: boolean;
  volume: number;
  playbackRate: number;
  formattedCurrentTime: string;
  formattedTotalDuration: string;
  isTranscriptVideoPlayer?: boolean;
  showSubtitles?: boolean;
  handlePlayPause: () => void;
  handleReplay: () => void;
  handleForward: () => void;
  handleMute: () => void;
  handlePlaybackRate: (rate: number) => void;
  handleVolume: (event: Event, value: number | number[], activeThumb: number) => void;
  handleVolumeSeekDown: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
  toggleFullScreen?: () => void;
  toggleSubtitles?: () => void;
}

const TSControls = ({
  isPlaying,
  isMuted,
  volume,
  playbackRate,
  formattedCurrentTime,
  formattedTotalDuration,
  isTranscriptVideoPlayer,
  showSubtitles,
  handlePlayPause,
  handleReplay,
  handleForward,
  handleMute,
  handlePlaybackRate,
  handleVolume,
  handleVolumeSeekDown,
  toggleFullScreen,
  toggleSubtitles,
}: TSControlsProps) => (
  <Grid container alignContent="center" sx={{ width: "100%", height: "48px", borderRadius: "5px", overflow: "hidden" }}>
    <Grid
      item
      xs={1}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {isTranscriptVideoPlayer ? (
        <Tooltip title="Esc to Play/Pause">
          <IconButton onClick={handlePlayPause} sx={{ ":focus": { outline: "none" } }}>
            {isPlaying ? (
              <Pause sx={{ color: "white", fontSize: "20px !important" }} />
            ) : (
              <PlayArrow sx={{ color: "white", fontSize: "20px !important" }} />
            )}
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton onClick={handlePlayPause} sx={{ ":focus": { outline: "none" } }}>
          {isPlaying ? (
            <Pause sx={{ color: "white", fontSize: "20px !important" }} />
          ) : (
            <PlayArrow sx={{ color: "white", fontSize: "20px !important" }} />
          )}
        </IconButton>
      )}
    </Grid>
    <Grid
      item
      xs={1}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {isTranscriptVideoPlayer ? (
        <Tooltip title="control + [  to skip back 5s">
          <IconButton onClick={handleReplay} sx={{ ":focus": { outline: "none" } }}>
            <Replay5 sx={{ color: "white", fontSize: "20px !important" }} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton onClick={handleReplay} sx={{ ":focus": { outline: "none" } }}>
          <Replay5 sx={{ color: "white", fontSize: "20px !important" }} />
        </IconButton>
      )}
    </Grid>
    <Grid
      item
      xs={1}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {isTranscriptVideoPlayer ? (
        <Tooltip title="control + ]  to skip forward 5s">
          <IconButton onClick={handleForward} sx={{ ":focus": { outline: "none" } }}>
            <Forward5 sx={{ color: "white", fontSize: "20px !important" }} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton onClick={handleForward} sx={{ ":focus": { outline: "none" } }}>
          <Forward5 sx={{ color: "white", fontSize: "20px !important" }} />
        </IconButton>
      )}
    </Grid>
    <Grid
      item
      xs={3}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        paddingRight: "10px",
      }}
    >
      <VolumeControl
        isMuted={isMuted}
        handleMute={handleMute}
        volume={volume}
        handleVolume={handleVolume}
        handleVolumeSeekDown={handleVolumeSeekDown}
      />
    </Grid>
    <Grid
      item
      xs={1}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <VideoRateControl playbackRate={playbackRate} handlePlaybackRate={handlePlaybackRate} />
    </Grid>
    <Grid
      item
      xs={5}
      sx={{
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: "8px",
      }}
    >
      {isTranscriptVideoPlayer && (
        <IconButton aria-label="subtitles" onClick={toggleSubtitles} sx={{ ":focus": { outline: "none" }, mr: 1 }}>
          {showSubtitles ? (
            <Subtitles sx={{ color: "white", fontSize: "20px !important", borderBottom: "3px solid #239B8B" }} />
          ) : (
            <Subtitles sx={{ color: "white", fontSize: "20px !important" }} />
          )}
        </IconButton>
      )}

      {isTranscriptVideoPlayer && (
        <IconButton aria-label="fullscreen" onClick={toggleFullScreen} sx={{ ":focus": { outline: "none" }, mr: 2 }}>
          <Fullscreen sx={{ color: "white", fontSize: "20px !important" }} />
        </IconButton>
      )}

      <Typography sx={{ fontSize: "14px !important" }}>
        {formattedCurrentTime}
        {" / "}
        {formattedTotalDuration}
      </Typography>
    </Grid>
  </Grid>
);

export default TSControls;
